import { useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';

import {
    FullBleed,
    Heading1,
    Stack,
} from '@myphx-engineering/phx-design-system';
import {
    ConsentListWithFilter,
    type ConsentSummary,
} from '@phx/consents/client';

import { GetAllConsentsDocument } from '../../../../graphql/generated/graphql';
import { getAbsoluteRoute } from '../../../../util/get-absolute-route';
import { Loader } from '../../../common/Loader';

export const ProfileConsentsPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const { data, loading, error } = useQuery(GetAllConsentsDocument);

    const consents = data?.app?.allConsents as ConsentSummary[];

    const handleConsentClick = (consentId: string) => {
        navigate(getAbsoluteRoute('profile.consents.consentId', { consentId }));
    };

    if (loading) return <Loader />;

    if (error) {
        return <Navigate to={getAbsoluteRoute('error')} />;
    }

    return (
        <Stack gap="lg" flex="1">
            <Heading1>{t('profile.consents.dataPrivacy')}</Heading1>

            <FullBleed breakpoint="md" color="gray" flex>
                <ConsentListWithFilter
                    consents={consents}
                    onConsentClick={handleConsentClick}
                />
            </FullBleed>
        </Stack>
    );
};
